import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("martinez_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
